import { m } from "#/paraglide/messages";

export default function GenericNotFoundComponent() {
	return (
		<div className="container py-12" role="alert">
			<title>{m.page_not_found_heading()}</title>
			<h1>{m.page_not_found_heading()}</h1>
			<p>{m.page_not_found_description()}</p>
		</div>
	);
}
